"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _ThemeProvider = require("../ThemeProvider");
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.a11yProps, _utils.viewProps]);
const selectProgressStyles = _ref => {
  let {
    backgroundColor,
    borderWidth,
    borderColor,
    borderRadius,
    height,
    shadow
  } = _ref;
  return {
    backgroundColor,
    borderWidth,
    borderColor,
    borderRadius,
    height,
    ...(0, _ThemeProvider.applyShadowToken)(shadow)
  };
};

/**
 * The `Progress` is a container for displaying one or several `ProgressBar`s.
 *
 * ## Props
 *
 * - Use `children` prop to pass one or multiple `ProgressBar`s. Note that in case of stacked progress bars
 *   each next will be displayed on top of the previous one.
 *
 * ## Tokens
 *
 * - Use the following tokens to customize the appearance:
 *   - `backgroundColor` for the background color of the progress container,
 *   - `borderColor` to control the color of the border,
 *   - `borderRadius` for the rounded corners,
 *   - `borderWidth` to change the border width.
 *   - `height` to control the height of the progress bars displayed within the progress bar container.
 *   - `shadow` to apply a box shadow to the progress bar container.
 *
 * ## Variants
 *
 * - Use the `size` variant to control the height of your progress bars:  passing `'mini'` will make your
 *   progress bar container narrower.
 *
 * ## Usability and A11y guidelines
 *
 * `Progress` component accepts the standard accessibility properties, however it's more important to make sure
 * its children (instances of `ProgressBar`) receive the accessibility properties specific to the `progressbar`
 * role.
 *
 */
const Progress = /*#__PURE__*/_react.default.forwardRef((_ref2, ref) => {
  let {
    children,
    tokens,
    variant,
    ...rest
  } = _ref2;
  const themeTokens = (0, _ThemeProvider.useThemeTokens)('Progress', tokens, variant);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
    ref: ref,
    style: [staticStyles.progressContainer, selectProgressStyles(themeTokens)],
    ...selectProps(rest),
    children: children
  });
});
Progress.displayName = 'Progress';
Progress.propTypes = {
  ...selectedSystemPropTypes,
  /**
   * Use the `children` prop to supply one or several `ProgressBar`s.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Progress tokens.
   */
  tokens: (0, _utils.getTokensPropType)('Progress'),
  /**
   * Progress variant.
   */
  variant: _utils.variantProp.propType
};
var _default = exports.default = Progress;
const staticStyles = _StyleSheet.default.create({
  progressContainer: {
    position: 'relative'
  }
});